import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id EF778205-36FD-4C55-BDFB-0373983C95D4
 * name alpha-k-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-k-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaKBoxIcon = createSvgIcon(<><path d="M9,7V17H11V13.67L13,17H15L12,12L15,7H13L11,10.33V7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z" /></>, 'AlphaKBoxIcon');
export default AlphaKBoxIcon